export const FETCH_COMMUNITIES = 'FETCH_COMMUNITIES'
export const EXPIRE_COMMUNITY = 'EXPIRE_COMMUNITY'
export const SERVER_RESOURCE = '/communities'
export const UPDATE_COMMUNITY = 'UPDATE_COMMUNITY'
export const UPDATE_COMMUNITY_SEARCH_STRING = 'UPDATE_COMMUNITY_SEARCH_STRING'
export const DELETE_COMMUNITY_PAYLOAD = {is_active: 0}



// WEBPACK FOOTER //
// ./src/pages/communities/constants.ts